<section class="landing-inversores__testimonials">
  <div class="landing-inversores__container landing-inversores__testimonials-inner">
    <div class="landing-inversores__testimonials-head">
      <div>
        <h2 class="landing-inversores__section-title">+20.000 inversores confían en nosotros</h2>
        <p class="landing-inversores__section-subtitle">Opiniones recogidas en Google.</p>
      </div>
      <a class="landing-inversores__testimonials-google-link" [href]="googleReviewsUrl" target="_blank" rel="noreferrer">
        <span class="landing-inversores__testimonials-google-g">G</span>
        Ver en Google
      </a>
    </div>

    <div class="landing-inversores__testimonials-grid">
      <figure
        class="landing-inversores__card landing-inversores__shadow-soft landing-inversores__testimonial-card"
        *ngFor="let t of testimonials"
      >
        <div class="landing-inversores__testimonial-card-stars">
          <landing-inversores-icon name="star" *ngFor="let s of stars"></landing-inversores-icon>
        </div>
        <blockquote class="landing-inversores__testimonial-card-quote">&ldquo;{{ t.quote }}&rdquo;</blockquote>
        <figcaption class="landing-inversores__testimonial-card-caption">
          <p class="landing-inversores__testimonial-card-name">{{ t.name }}</p>
          <p class="landing-inversores__testimonial-card-role">{{ t.role }}</p>
        </figcaption>
      </figure>
    </div>
  </div>
</section>
